import { TEAM_BUDGET_PAYMENT_COPY } from '../constants/copy'

/**
 * SN-8441 / SN-8442 — the line under Due Today once the rep's choice is priced: the
 * tax the amount includes (only when there is any), and when the team registers.
 */
export const pricedCheckoutNote = ({
  tax,
  formatAmount,
}: {
  /** The checkout's tax, in currency units. */
  tax: number
  /** Renders an amount in the currency the payment is charged in. */
  formatAmount: (amount: number) => string
}): string =>
  tax > 0
    ? `Includes ${formatAmount(tax)} tax. ${
        TEAM_BUDGET_PAYMENT_COPY.registeredOncePaid
      }`
    : TEAM_BUDGET_PAYMENT_COPY.registeredOncePaid
